import { defineMessages } from 'react-intl';

export default defineMessages({
  bedFrameTitle: {
    id: 'PdpV2.BedFrameAOV.title',
    description: 'Bed Frame AOV title',
    defaultMessage: 'Select bed frame',
  },
  discountBadge: {
    id: 'PdpV2.BedFrameAOV.discountBadge',
    description: 'Discount Badge Text',
    defaultMessage: '{discount} off',
  },
  expand: {
    id: 'PdpV2.BedFrameAOV.expand',
    description: 'More bed frame options',
    defaultMessage: 'More bed frame options',
  },
  freeInHomeSetupWithDiscount: {
    id: 'PdpV2.ProductCard.freeInHomeSetupWithDiscount',
    description: 'Free in-home setup description for discount',
    defaultMessage:
      'Free In-Home Setup with Mattress and Smart Base Purchase ({pricing} value)',
  },
  freeInHomeSetupWithoutDiscount: {
    id: 'PdpV2.ProductCard.freeInHomeSetupWithoutDiscount',
    description: 'Free in-home setup description for no discount',
    defaultMessage: 'Free In-Home Setup with Mattress and Smart Base Purchase',
  },
});
